'use client';

import Link from 'next/link';

import { buttonBase, buttonVariants } from '@/components/ui/Button';
import Text from '@/components/ui/Text';
import { cn } from '@/utils/cn';
import { useAnchorNav } from '@/hooks/useAnchorNav';

const ButtonLink = ({
  href,
  variant = 'ghost',
  arrow = false,
  className,
  target,
  rel,
  onClick,
  children,
}: ButtonLinkProps) => {
  const { handleAnchorClick } = useAnchorNav();
  const isAnchor = href.includes('#');

  return (
    <Link
      href={href}
      scroll={!isAnchor}
      target={target}
      rel={rel}
      onClick={(e) => {
        if (isAnchor) handleAnchorClick(e, href);
        onClick?.(e);
      }}
      className={cn(buttonBase, buttonVariants[variant], className)}
    >
      <Text as="span" variant={variant === 'text' ? 'cardLink' : 'ctaButton'}>
        {children}
        {arrow && (
          <span aria-hidden="true" className="pl-2">
            →
          </span>
        )}
      </Text>
    </Link>
  );
};

export default ButtonLink;

type ButtonLinkProps = {
  href: string;
  variant?: 'primary' | 'secondary' | 'ghost' | 'text';
  arrow?: boolean;
  className?: string;
  target?: string;
  rel?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  children: React.ReactNode;
};
